// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jsonWrapper--2eW8A9fs {\n  display: flex;\n}\n.text--2Grf33cY {\n  overflow: hidden;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jsonWrapper": "jsonWrapper--2eW8A9fs",
	"text": "text--2Grf33cY"
};
export default ___CSS_LOADER_EXPORT___;
